module.exports = __webpack_public_path__ + "assets/img/focus.0d2a43d7.jpg";